<template>
  <v-row>
    <v-col cols="4" class="grey--text py-0 body-2 text-right px-2 text_row_title" style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">{{ title }}</v-col>
    <v-col cols="8" class="py-0 pl-1 pr-3 body-2 justify-center">
      <country-flag v-if="flag !== null" :country="flag" size="small" />
      <span v-if="text !== undefined" :class="textClass">{{ format(text) }}</span>
      <slot v-else />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "TextRow",
  props: {
    title: {
      type: String,
      default: null
    },
    text: {
      type: String,
    },
    textClass: {
      type: String,
      default: ""
    },
    enumCode: {
      type: String,
      default: null
    },
    flag: {
      type: String,
      default: null
    }
  },

  methods: {
    format(value) {
      if (value === undefined || value === null)
        return "-";
      else if (this.enumCode !== null)
        return this.$t("enum." + this.enumCode + "." + value);
      else
        return value;
    }
  }
};
</script>

<style lang="sass" scoped>
.text_row_title
  padding-top: 3px
  padding-bottom: 0px

</style>